<template>
  <div>
    <b-overlay :show="isWait" rounded="sm" no-fade>
      <b-card-actions title="Thêm hồ sơ" class="m-50" action-collapse>
        <b-card-text>
          <b-row>
            <b-col md="9">
              <b-form-group label="" label-for="hoVaTen">
                <vue-dropzone
                  ref="myVueDropzone"
                  id="dropzone"
                  :use-custom-slot="true"
                  :options="dropzoneOptions"
                  v-on:vdropzone-success="UploadFile"
                  v-on:vdropzone-removed-file="removeThisFile"
                  v-on:vdropzone-max-files-exceeded="maxFile"
                >
                  <div class="dropzone-custom-content">
                    <feather-icon
                      icon="DownloadCloudIcon"
                      size="3x"
                      class="mb-2"
                    />
                    <h5>Kéo thả hoặc bấm vào để tải tệp tin</h5>
                  </div></vue-dropzone
                >
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="" label-for="">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-success"
                  block
                  :href="defaultFile"
                >
                  <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="FileIcon"
                    size="16"
                  />
                  Tải file mẫu
                </b-button>
              </b-form-group>
              <b-form-group label="" label-for="">
                <b-button
                  v-if="isSuccess"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="button"
                  block
                  variant="primary"
                  :disabled="isWait"
                  @click="submit"
                >
                  Lưu
                </b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card-actions>
      <b-card-actions title="Thêm nhiều hồ sơ" class="m-50" action-collapse>
        <b-card-text>
          <b-row>
            <b-col md="9">
              <b-form-group label="" label-for="hoVaTen">
                <vue-dropzone
                  ref="myVueDropzoneMulti"
                  id="dropzone"
                  :use-custom-slot="true"
                  :options="dropzoneOptionsMulti"
                  v-on:vdropzone-success="UploadFileMulti"
                  v-on:vdropzone-removed-file="removeThisFileMulti"
                  v-on:vdropzone-max-files-exceeded="maxFileMulti"
                >
                  <div class="dropzone-custom-content">
                    <feather-icon
                      icon="DownloadCloudIcon"
                      size="3x"
                      class="mb-2"
                    />
                    <h5>Kéo thả hoặc bấm vào để tải tệp tin</h5>
                  </div></vue-dropzone
                >
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="" label-for="">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-success"
                  block
                  :href="defaultFileMulti"
                >
                  <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="FileIcon"
                    size="16"
                  />
                  Tải file mẫu
                </b-button>
              </b-form-group>
              <b-form-group label="" label-for="">
                <b-button
                  v-if="isSuccessMulti"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="button"
                  block
                  variant="primary"
                  :disabled="isWait"
                  @click="submitMulti"
                >
                  Lưu
                </b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card-actions>

      <b-card-actions
        title="Thêm nhiều hồ sơ( thông tin cơ bản)"
        class="m-50"
        action-collapse
      >
        <b-card-text>
          <b-row>
            <b-col md="9">
              <b-form-group label="" label-for="hoVaTen">
                <vue-dropzone
                  ref="myVueDropzoneShort"
                  id="dropzone"
                  :use-custom-slot="true"
                  :options="dropzoneOptionsShort"
                  v-on:vdropzone-success="UploadFileShort"
                  v-on:vdropzone-removed-file="removeThisFileShort"
                  v-on:vdropzone-max-files-exceeded="maxFileShort"
                >
                  <div class="dropzone-custom-content">
                    <feather-icon
                      icon="DownloadCloudIcon"
                      size="3x"
                      class="mb-2"
                    />
                    <h5>Kéo thả hoặc bấm vào để tải tệp tin</h5>
                  </div></vue-dropzone
                >
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="" label-for="">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-success"
                  block
                  :href="defaultFileShort"
                >
                  <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="FileIcon"
                    size="16"
                  />
                  Tải file mẫu
                </b-button>
              </b-form-group>
              <b-form-group label="" label-for="">
                <b-button
                  v-if="isSuccessShort"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="button"
                  block
                  variant="primary"
                  :disabled="isWait"
                  @click="submitMultiShort"
                >
                  Lưu
                </b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card-actions>

      <!-- eslint-disable -->
      <b-card no-body v-if="isShowTable">
        <b-table
          striped
          hover
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          class="position-relative"
          :items="dataTable"
          :fields="fields"
          empty-text="Không có dữ liệu"
          table-class="vgt-table cs-table-info"
        >
          <template #cell(STT)="data">
            {{ data.index + (currentPage - 1) * perPage + 1 }}
          </template>
          <template #cell(donVi)="data"> {{ data.value.ten }} </template>
          <template #cell(column)="data">
            <span class="text-center">{{ data.item.column }}. </span
            >{{ data.item.nameCell }}
          </template>
          <template #cell(row)="data"> Dòng {{ data.item.row }} </template>
        </b-table>
        <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
          <b-form-group class="text-nowrap mb-md-0 mr-1">
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
            />
          </b-form-group>

          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BCollapse,
  VBToggle,
  BButton,
  BCardText,
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BFormInput,
  BTable,
  BFormSelect,
  BCardBody,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Ripple from "vue-ripple-directive";
import { ref } from "@vue/composition-api";
import vueDropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  Import,
  ImportMulti,
  ImportMultiShort,
} from "@/services/api/HoSoCanBoCongChuc/ImportCanBoCongChucService";

export default {
  components: {
    vueDropzone,
    BButton,
    BRow,
    BCol,
    BCardActions,
    BCardText,
    vSelect,
    BCollapse,
    BCard,
    Treeselect,
    BFormGroup,
    BFormInput,
    BTable,
    BFormSelect,
    BCardBody,
    BPagination,
    BOverlay,
  },
  directives: {
    "b-toggle": VBToggle,
    Ripple,
  },
  data() {
    return {
      isWait: false,
      isShowTable: false,
      isSuccess: false,
      isSuccessMulti: false,
      isSuccessShort: false,
      defaultFile:
        process.env.VUE_APP_BASE_API + "/files/get-file-template/IMPORT",
      defaultFileMulti:
        process.env.VUE_APP_BASE_API + "/files/get-file-template/MULTI",
      defaultFileShort:
        process.env.VUE_APP_BASE_API + "/files/get-file-template/MULTISHORT",
      dropzoneOptions: {
        url: `${process.env.VUE_APP_BASE_API}/files/importExcel`,
        thumbnailWidth: 300,
        maxFiles: 1,
        maxFilesize: 30,
        headers: { "My-Awesome-Header": "header value" },
        acceptedFiles: ".xlsx, .xls",
        // addRemoveLinks: true,
        previewTemplate: this.template(),
      },
      dropzoneOptionsMulti: {
        url: `${process.env.VUE_APP_BASE_API}/files/importExcelMultiCBCC`,
        thumbnailWidth: 300,
        maxFiles: 1,
        maxFilesize: 30,
        headers: { "My-Awesome-Header": "header value" },
        acceptedFiles: ".xlsx, .xls",
        // addRemoveLinks: true,
        previewTemplate: this.template(),
      },
      dropzoneOptionsShort: {
        url: `${process.env.VUE_APP_BASE_API}/files/importExcelMultiShortCBCC`,
        thumbnailWidth: 300,
        maxFiles: 1,
        maxFilesize: 30,
        headers: { "My-Awesome-Header": "header value" },
        acceptedFiles: ".xlsx, .xls",
        // addRemoveLinks: true,
        previewTemplate: this.template(),
      },
      dataTable: [],
      perPage: 10,
      pageOptions: [10, 25, 50],
      totalRow: 1,
      currentPage: 1,

      fieldsError: [
        {
          key: "STT",
          label: "STT",
          class: "text-center",
          thStyle: " width:50px",
        },
        {
          key: "row",
          label: "Dòng",
          class: "text-center pl-0 pr-0 ",
          thStyle: " width:100px",
        },
        {
          key: "column",
          label: "Cột",
          class: "text-center",
        },
        {
          key: "error",
          label: "Lý do dữ liệu không hợp lệ",
          sortable: true,
        },
        {
          key: "worksheetName",
          label: "Nhóm thông tin",
        },
      ],
      fieldsSuccess: [
        {
          key: "STT",
          label: "STT",
          thStyle: "text-align:center; width:50px",
        },
        {
          key: "soCccd",
          label: "Số CCCD",
          sortable: true,
        },
        {
          key: "hoVaTen",
          label: "Họ và tên",
          thStyle: "text-align:center; ",
        },
        {
          key: "ngaySinhShow",
          label: "Ngày sinh",
        },
        {
          key: "donVi",
          label: "Đơn vị sử dụng",
          thStyle: "text-align:center;",
        },
      ],
      fieldsSuccessShort: [
        {
          key: "STT",
          label: "STT",
          thStyle: "text-align:center; width:50px",
        },
        {
          key: "soCccd",
          label: "Số CCCD",
          sortable: true,
        },
        {
          key: "hoVaTen",
          label: "Họ và tên",
          thStyle: "text-align:center; ",
        },
        {
          key: "email",
          label: "Email",
        },
        {
          key: "userName",
            label: "Tài khoản (UserName)",
          thStyle: "text-align:center;",
        },
      ],
      model: {},
    };
  },
  created() {},
  computed: {
    totalRows() {
      if (this.dataTable && this.dataTable.length > 0)
        return this.dataTable.length;
      else return 0;
    },
  },
  methods: {
    template: function () {
      return `<div class="dz-preview dz-file-preview">
                <div class="dz-details p-0">
                    <div class="dz-size text-right"><span data-dz-remove><i class="fa fa-close"></i></span></div>
                    <div class="dz-filename p-1"><span data-dz-name></span></div>
                </div>
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                <div class="dz-error-message"><span data-dz-errormessage></span></div>
                <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                <div class="dz-error-mark"><i class="fa fa-close"></i></div>

            </div>
        `;
    },
    UploadFile(file, response) {
      this.isWait = true;
      this.$refs.myVueDropzoneMulti.removeAllFiles();
      this.$refs.myVueDropzoneShort.removeAllFiles();
      if (response.code == "SUCCESS") {
        console.log("detail", response.data);
        this.isShowTable = true;
        this.dataTable = [];
        this.model = response.data;
        this.dataTable.push(response.data);
        this.fields = this.fieldsSuccess;
        this.isSuccess = true;
        this.isSuccessMulti = false;
        this.isSuccessShort = false;
      } else {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Thất bại",
            icon: "AlertTriangleIcon",
            variant: "error",
            text: response.message,
          },
        });
        console.log("detail", response.detail);
        this.isShowTable = true;
        this.dataTable = response.detail;
        this.fields = this.fieldsError;
        this.isSuccess = false;
        this.isSuccessMulti = false;
        this.isSuccessShort = false;
        // this.totalRows = respone.detail ? respone.detail.length : 0;
      }
      // this.$refs.myVueDropzone.removeAllFiles();
      this.isWait = false;
    },
    UploadFileMulti(file, response) {
      this.isWait = true;
      this.$refs.myVueDropzone.removeAllFiles();
      this.$refs.myVueDropzoneShort.removeAllFiles();
      if (response.code == "SUCCESS") {
        console.log("detail", response);
        this.isShowTable = true;
        this.dataTable = [];
        this.model = response.data;
        this.dataTable = response.data;
        this.fields = this.fieldsSuccess;
        this.isSuccessMulti = true;
        this.isSuccess = false;
        this.isSuccessShort = false;
      } else {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Thất bại",
            icon: "AlertTriangleIcon",
            variant: "error",
            text: response.message,
          },
        });
        console.log("detail", response.detail);
        this.isShowTable = true;
        this.dataTable = response.detail;
        this.fields = this.fieldsError;
        this.isSuccessMulti = false;
        this.isSuccess = false;
        this.isSuccessShort = false;
        // this.totalRows = respone.detail ? respone.detail.length : 0;
      }
      // this.$refs.myVueDropzone.removeAllFiles();
      this.isWait = false;
    },
    UploadFileShort(file, response) {
      this.isWait = true;
      this.$refs.myVueDropzone.removeAllFiles();
      this.$refs.myVueDropzoneMulti.removeAllFiles();
      if (response.code == "SUCCESS") {
        console.log("detail", response);
        this.isShowTable = true;
        this.dataTable = [];
        this.model = response.data;
        this.dataTable = response.data;
        this.fields = this.fieldsSuccessShort;
        this.isSuccessShort = true;
        this.isSuccessMulti = false;
        this.isSuccess = false;
      } else {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Thất bại",
            icon: "AlertTriangleIcon",
            variant: "error",
            text: response.message,
          },
        });
        console.log("detail", response.detail);
        this.isShowTable = true;
        this.dataTable = response.detail;
        this.fields = this.fieldsError;
        this.isSuccessShort = false;
        this.isSuccessMulti = false;
        this.isSuccess = false;

        // this.totalRows = respone.detail ? respone.detail.length : 0;
      }
      // this.$refs.myVueDropzone.removeAllFiles();
      this.isWait = false;
    },
    maxFile(file) {
      this.$refs.myVueDropzone.removeAllFiles();
      this.$refs.myVueDropzone.addFile(file);
    },
    maxFileShort(file) {
      this.$refs.myVueDropzoneShort.removeAllFiles();
      this.$refs.myVueDropzoneShort.addFile(file);
    },
    maxFileMulti(file) {
      this.$refs.myVueDropzoneMulti.removeAllFiles();
      this.$refs.myVueDropzoneMulti.addFile(file);
    },
    removeThisFile(file, error, xhr) {
      this.$refs.myVueDropzone.removeAllFiles();
      this.isShowTable = false;
      this.isSuccess = false;
    },
    removeThisFileMulti(file, error, xhr) {
      this.$refs.myVueDropzoneMulti.removeAllFiles();
      this.isShowTable = false;
      this.isSuccessMulti = false;
    },
    removeThisFileShort(file, error, xhr) {
      this.$refs.myVueDropzoneShort.removeAllFiles();
      this.isShowTable = false;
      this.isSuccessShort = false;
    },
    submit() {
      Import(this.model).then((res) => {
        this.isWait = true;
        if (res.isError) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thất bại",
              icon: "AlertTriangleIcon",
              variant: "error",
              text: res.message,
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thành công",
              icon: "CheckIcon",
              variant: "success",
              text: res.message,
            },
          });
          this.isSuccess = false;
        }
        this.isWait = false;
      });
    },
    submitMulti() {
      ImportMulti(this.model).then((res) => {
        this.isWait = true;
        if (res.isError) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thất bại",
              icon: "AlertTriangleIcon",
              variant: "error",
              text: res.message,
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thành công",
              icon: "CheckIcon",
              variant: "success",
              text: res.message,
            },
          });
          this.isSuccessMulti = false;
        }
        this.isWait = false;
      });
    },
    submitMultiShort() {
      ImportMultiShort(this.model).then((res) => {
        this.isWait = true;
        if (res.isError) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thất bại",
              icon: "AlertTriangleIcon",
              variant: "error",
              text: res.message,
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thành công",
              icon: "CheckIcon",
              variant: "success",
              text: res.message,
            },
          });
          this.isSuccessShort = false;
        }
        this.isWait = false;
      });
    },
  },

  props: {},
  setup(props, { emit }) {
    return {};
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
#dropzone {
  font-family: "Arial", sans-serif;
  letter-spacing: 0.2px;
  transition: background-color 0.2s linear;
  border: dashed 1px #056717;
  border-radius: 0.375rem;
}

#dropzone .dz-preview {
  width: 96%;
  display: inline-block;
  margin: 10px;
  //   min-height: 50px;
}
#dropzone .dz-preview .dz-image-preview {
  background: #28c76f;
}
.vue-dropzone > .dz-preview .dz-details {
  background-color: #107c4114;
  // padding: 14px;
  border-radius: 4px;
  position: relative;
  color: #000;
}

#dropzone .dz-preview .dz-image > div {
  width: inherit;
  height: inherit;
  border-radius: 50%;
  background-size: contain;
}
#dropzone .dz-preview .dz-image > img {
  width: 100%;
}
</style>
